import {
  GetDraftQSetsDocument,
  GetQSetByIdDocument,
  SearchQSetsDocument,
  useDeleteQSetByIdMutation,
} from '@exam-management/graphql';
import { useNavigate, useParams } from '@exam-management/router';
import { ConfirmationModal, Text } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { useCallback } from 'react';

interface QSetDeletionModalProps {
  qSetId: string;
  open: boolean;
  onClose: () => void;
}

export default function QSetDeletionModal(props: Readonly<QSetDeletionModalProps>) {
  const { qSetId, open: isOpen, onClose } = props;
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { courseId } = useParams('/exam-courses/:courseId/qsets');

  const [deleteQSetById, { loading: isLoading }] = useDeleteQSetByIdMutation({
    onCompleted: () => {
      onClose();
      showSnackbar({
        message: 'QSet has been deleted',
        variant: 'success',
      });
      navigate('/exam-courses/:courseId/qsets', {
        params: {
          courseId: courseId,
        },
      });
    },
    onError: () => {
      showSnackbar({
        message: 'Failed to delete QSet',
        variant: 'error',
      });
    },
    refetchQueries: [
      GetDraftQSetsDocument,
      SearchQSetsDocument,
      {
        query: GetQSetByIdDocument,
        variables: {
          getQSetByIdInput: {
            qSetId,
          },
        },
      },
    ],
  });

  const handleDelete = useCallback(() => {
    deleteQSetById({
      variables: {
        input: {
          id: qSetId,
        },
      },
    });
  }, [qSetId]);

  return (
    <ConfirmationModal
      open={isOpen}
      title='Delete QSet'
      content={<Text>คุณต้องการลบชุดข้อสอบนี้ใช่หรือไม่?</Text>}
      acceptText='Delete'
      variant='error'
      onAccept={handleDelete}
      onDiscard={onClose}
      onClose={onClose}
      loading={isLoading}
    />
  );
}
